
import { motion } from "framer-motion";

export function AuthHeader() {
  return (
    <motion.div 
      className="text-center mb-8"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="w-32 h-32 mx-auto mb-4 relative">
        <motion.img 
          src="/lovable-uploads/79d8bcfe-3886-4213-8a67-03bfd18571be.png" 
          alt="Edaptica Logo" 
          className="w-full h-full object-contain drop-shadow-md"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        />
      </div>
      <motion.h1 
        className="text-6xl font-bold font-playfair bg-gradient-to-r from-[#FF9933] via-[#2F9FEB] to-[#138808] bg-clip-text text-transparent mb-4 animate-fadeIn drop-shadow-lg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.6 }}
      >
        Edaptica
      </motion.h1>
      <motion.p 
        className="text-2xl text-foreground/90 font-medium tracking-wider animate-slideIn bg-clip-text text-transparent bg-gradient-to-r from-gray-700 to-gray-900 dark:from-gray-100 dark:to-white"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.5 }}
      >
        Intelligence That Adapts to You
      </motion.p>
    </motion.div>
  );
}
